import React from 'react';
import Icon from '@mdi/react';
import { vars } from '../../../Theme';
import { mdiSync } from '@mdi/js';
import { Button } from '@mui/material';

const loadingButtonSx = {
    width: '34px',
    height: '34px',
    borderRadius: '5px',
    minWidth: '34px',
    padding: '0',
    border: `1px solid ${vars.lightGray}`,
    '&:hover': {
        backgroundColor: vars.fillGray,
    },
    '& circle': {
        stroke: vars.brandGreen,
    },
};
export default ({ handleOnClick, isLoading }: IRefreshButtonProps) => {
    return (
        <Button loading={isLoading} sx={loadingButtonSx} onClick={handleOnClick}>
            {!isLoading && <Icon path={mdiSync} size={1} color={vars.font} />}
        </Button>
    );
};

interface IRefreshButtonProps {
    handleOnClick: () => void;
    isLoading: boolean;
}
